import { Alert, Box } from '@mui/material'
import { useField } from 'formik'
import React from 'react'
import { useAppTranslations } from '../../utils/hooks/useAppTranslations'
import { useUrlRedirectCheck } from '../../utils/hooks/useUrlRedirectCheck'

interface UrlRedirectCheckProps {
  name: string
}

const UrlRedirectCheck: React.FC<UrlRedirectCheckProps> = ({ name }) => {
  const t = useAppTranslations()
  const [field] = useField<string>(name)
  const outcome = useUrlRedirectCheck(name, field.value ?? '')

  if (!outcome || outcome.kind === 'none') {
    return null
  }

  if (outcome.kind === 'warning') {
    const message =
      outcome.reason === 'expiredCertificate'
        ? t('commons.urlCheck.expiredCertificate')
        : outcome.reason === 'httpError'
          ? t('commons.urlCheck.httpError', { status: outcome.httpStatus ?? '' })
          : t('commons.urlCheck.requestFailed')

    return (
      <Box sx={{ mt: 0.5, width: '100%' }}>
        <Alert severity="warning" sx={{ py: 0.25 }}>
          {message}
        </Alert>
      </Box>
    )
  }

  const message = outcome.finalUrl
    ? t('commons.urlCheck.redirectsTo', { url: outcome.finalUrl })
    : t('commons.urlCheck.redirectDetected')

  return (
    <Box sx={{ mt: 0.5, width: '100%' }}>
      <Alert severity="info" sx={{ py: 0.25 }}>
        {message}
      </Alert>
    </Box>
  )
}

export default UrlRedirectCheck
